export class ConnectorAwsAccountProperties {
    'awsAccountId';
    'discoveryRoleName';
    'dataAccessRoleName';
    'version';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "discoveryRoleName",
            "baseName": "discoveryRoleName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataAccessRoleName",
            "baseName": "dataAccessRoleName",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectorAwsAccountProperties.attributeTypeMap;
    }
    constructor() {
    }
}
